import { Pipe, PipeTransform } from '@angular/core';

import { recursoCampanhaTipos } from '../recurso-campanha-tipo';

@Pipe({
    name: 'recursoCampanhaTipo'
})
export class RecursoCampanhaTipoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = recursoCampanhaTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return recursoCampanhaTipos[index].nome;
        }
        return '';
    }
}
